// 「50 X 50 INTERVIEWS」バナー（v3と同じ実装）。
// data-images 属性（URL配列）を持つ要素内の img の src を一定間隔でランダムに差し替える。
export function fiftyInterviewsBanner() {
  const config = {
    interval: 1000, // 画像の切り替え間隔（ミリ秒）
  };

  const containers = document.querySelectorAll('[data-images]');
  containers.forEach((container) => {
    const img = container.querySelector('img');
    let srcs = [];
    try {
      srcs = JSON.parse(container.dataset.images || '[]');
    } catch (e) {
      return;
    }
    if (!img || srcs.length < 2) return;

    // 全画像を先読みしてデコードまで済ませ、完了してから切り替えを開始する。
    // 参照を配列に保持しておくことでGCによるキャッシュ破棄も防ぐ。
    const preloads = srcs.map((src) => {
      const preload = new Image();
      preload.src = src;
      return preload;
    });

    Promise.all(preloads.map((preload) => preload.decode().catch(() => {}))).then(() => {
      let currentIndex = Math.max(0, srcs.indexOf(img.getAttribute('src')));

      setInterval(() => {
        // 現在表示中とは違う画像をランダムに選ぶ
        let nextIndex;
        do {
          nextIndex = Math.floor(Math.random() * srcs.length);
        } while (nextIndex === currentIndex);

        img.src = srcs[nextIndex];
        currentIndex = nextIndex;
      }, config.interval);
    });
  });
}
